import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import { LeftOutlined } from '@ant-design/icons';

import {
  Layout,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  DatePicker,
  Col,
  InputNumber,
  Divider,
  Button,
  Modal,
  List,
  Spin
} from "antd";

//OTHER IMPORTS
import dayjs from 'dayjs';

import { BOM } from "../../../../../services/definedMethod";
import cnt from "../../../../../services/definedConstant";

import CustomButton from '../../../../../components/custom/CustomButton';
import MainLayout from '../../../../../components/layouts/MainLayout';
import TopContent from '../../../../../components/layouts/TopContent';
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";

const { Text } = Typography

const AddLoanCharge = (props) => {

  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();

  const { state } = useLocation();

  const [isLoading, setIsLoading] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [chargeTimeType, setChargeTimeType] = useState(false);
  const [chargesData, setChargesData] = useState([]);
  const [chargesTemplate, setChargesTemplate] = useState([]);
  const dateFormat = 'YYYY/MM/DD';

  useEffect(() => {
    getTemplate();
    defaultDate()
    // console.log(chargesData)
  }, []);

  const defaultDate = () => {
    useForm.setFieldsValue({
      dueDate: dayjs(),
    })
  }

  function getTemplate() {

    const url = `${apiConfig.LoanAccounts}/${state.id}/charges/template`
    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {

      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objList = res;

        setChargesTemplate(objList)

        let tempCharges = [];

        objList?.chargeOptions?.forEach((element) => {
          tempCharges.push({
            value: element.id,
            label: element.name,
            amount: element?.amount,
          });
        });

        setChargesData(tempCharges);

      }
    });
  }

  function onSelectCharge(valueParam) {
    setShowOptions(true);

    let charge = chargesTemplate.chargeOptions.find((element) => element.id === valueParam)

    useForm.setFieldsValue({
      amount: charge?.amount,
      chargeCalculationType: charge?.chargeCalculationType?.value,
      chargeTimeType: charge?.chargeTimeType?.value,
    });

    if (charge?.chargeTimeType?.value === "Specified due date") {
      setChargeTimeType(true)
    }

  }

  function onCancel() {
    navigate("/detail-loan-account", { state: state });
  }

  const onSubmit = (formValues) => {

    const url = `${apiConfig.LoanAccounts}/${state.id}/charges`

    formValues.dueDate = BOM.DateTime(formValues.dueDate, "only-date")

    delete formValues.chargeCalculationType
    delete formValues.chargeTimeType

    const body = {
      ...formValues,
      locale: "en",
      method: "POST",
      dateFormat: "dd MMMM yyyy",
      session,
    };

    // return
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.addLoanChargeMsg);
        navigate("/detail-loan-account", { state: state });
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <MainLayout isEnableRightSidebar={true} >
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.addLoanCharge}
        pageItems={staticConfig.addLoanChargeBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}

          title={
            <Row
              style={{
                alignContent: "center",
                width: "8%",
              }}
            >
              <Button
                icon={<LeftOutlined />}
                type="text"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
                onClick={onCancel}
              >
                <Text
                  style={{ marginTop: "auto", marginBottom: "auto", fontSize: 15 }}
                >
                  Back
                </Text>
              </Button>
            </Row>
          }
        >
          <Form
            form={useForm}
            layout="vertical"
            onFinish={onSubmit}
          >

            <Row >
              <Divider />

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.charge}
                  name={"chargeId"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(
                        labelConfig.charge
                      ),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.charge,
                      "select"
                    )}
                    options={chargesData}
                    onChange={onSelectCharge}
                    showSearch
                  />
                </Form.Item>
              </Col>

            </Row>

            {showOptions &&
              <Row>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.amount}
                    name="amount"
                  >
                    <Input
                      placeholder={BOM.handlePlaceholderMsg(
                        `${labelConfig.amount}`,
                        "select"
                      )}
                    />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.chargeCalculation}
                    name="chargeCalculationType"
                  >
                    <Input
                      placeholder={BOM.handlePlaceholderMsg(
                        `${labelConfig.chargeCalculation}`,
                        "select"
                      )}
                      disabled
                    />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.chargeTime}
                    name="chargeTimeType"
                  >
                    <Input
                      placeholder={BOM.handlePlaceholderMsg(
                        `${labelConfig.chargeTime}`,
                        "select"
                      )}
                      disabled
                    />
                  </Form.Item>
                </Col>

                {
                  chargeTimeType === true ?
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={labelConfig.dueOn}
                        name="dueDate"
                        rules={[
                          {
                            required: true,
                            message: BOM.CheckReqFld(
                              labelConfig.dueOn
                            ),
                          },
                        ]}
                      >
                        <DatePicker
                          placeholder={BOM.handlePlaceholderMsg(
                            `${labelConfig.dueOn}`,
                            "select"
                          )}
                          style={{ width: '100%' }}
                          format={dateFormat}
                        />
                      </Form.Item>
                    </Col>
                    : null
                }
              </Row>
            }

            <Row>
              <Divider />
              <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#92428B"
                colorText="white"
                hoverBackground="#AD4EA7"
              />

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>

    </MainLayout>
  )
}

export default AddLoanCharge